import React,{ useEffect, useState, useContext }  from 'react';
import { useSortable } from "@dnd-kit/sortable";
import './Components.css';
import { CSS } from '@dnd-kit/utilities';
import { MasterCapabilitiesList, LMList } from '../utils/LMConstants';
import { StarIcon, StarIconEmpty } from '../icons/Icons';
import { ThemeContext } from '../contexts/AppContext';

function Widget({ id, title, value, unit, std, avg, launchmonitor, isFavorite, SetFavorite, isEditing = false, touchAction = 'none' }) {

    const { theme, setAppTheme } = useContext(ThemeContext);
    const [currentTheme, setCurrentTheme] = useState(theme);

    const isEmpty = !launchmonitor;

    useEffect(() => {
        setCurrentTheme(theme);
        }, [theme]);

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? "100" : "1",
        opacity: isDragging ? 0.3 : 1,
        backgroundColor: isEmpty ? 'transparent' : getComputedStyle(document.documentElement).getPropertyValue('--background-secondary')
    };

    const lmTitleStyle = {
        backgroundColor: !isEmpty ? LMList.find(l => l.type === launchmonitor).color : 'transparent',
        width: "100%"
    };

    function FavoriteButton() {
        if (isFavorite) {
            return <StarIcon />;
        } else {
            return <StarIconEmpty />;
        }
    }
    const contextClick = (e) => {
        e.preventDefault();
        if(setNodeRef.current){
            setNodeRef.current.click();
        }
    }

    return (
        <>
        {isEmpty && (
            <div ref={setNodeRef} style={{ position: 'relative', padding: '10px', touchAction }}>
              <div className="widget" style={style}>
              </div>
          </div>
        )}
        <></>
        {!isEmpty && (
            <div ref={setNodeRef} style={{ position: 'relative', padding: '10px', touchAction }}>
            {(!isEmpty && !isDragging && SetFavorite !== undefined && isEditing) && (
                      <button
                          className="widget-button"
                          style={{ background: 'transparent' }}
                          onClick={(e) => {
                              e.stopPropagation(); // Prevent click from propagating
                              SetFavorite(id); // Call the favorite handler
                          }}
                      >
                          {FavoriteButton()}
                      </button>
                  )}
              <div className="widget" style={style} {...attributes} {...listeners} onContextMenu={contextClick}>
                  <div className='widget-lm' style={lmTitleStyle}>{title}</div>
                  <div className="widget-value">{value}</div>
                  <div className='widget-footer'>
                      <div className="widget-foot" style={{paddingLeft:'10px'}}>{avg ? avg : '--'}</div>
                      <div className="widget-unit" style={{margin:'0 auto'}}>{unit}</div>
                      <div className="widget-foot" style={{paddingRight:'10px'}}>{"±" + (std ? std : '--')}</div>
                  </div>
              </div>
          </div>
        )}
        </>
    );
}

export default Widget;
